import React, { useEffect, useRef } from "react";
import { TimeSlider } from "./TimeSlider";
import styled from "styled-components";
import {
  Time
} from "../../pace-fns/pace-fns";

type TimePickerComponentProps = {
    onSelectionFinish(time: Time): void;
    closePicker(): void;
    time: Time;
  };
  
  const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 100%;
`;

  export const TimePicker = ({
    time,
    onSelectionFinish,
    closePicker
  }: TimePickerComponentProps) => {
  
    const node = useRef(null);
  
    const handleClick = (event: Event) => {
      if (!(node?.current as any).contains(event.target)) {
        closePicker();
      }
    };
    useEffect(() => {
      document.addEventListener("mousedown", handleClick);
  
      return () => document.removeEventListener("mousedown", handleClick);
    }, []);
  
    return (
      <Container ref={node}>
        <TimeSlider time={time} onSelectionFinish={onSelectionFinish} />
      </Container>
    );
  };